"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _ciamAuthWebClientLib = require("@eon-funke/ciam-auth-web-client-lib");
var _Stepbox = _interopRequireDefault(require("../../components/Stepbox/Stepbox"));
var _LinkExpired = _interopRequireDefault(require("../../components/LinkExpired/LinkExpired"));
var BASE_CLASS = 'register-confirmation';
var RegisterConfirmationProps = {
  stepOne: _propTypes.default.shape({
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    text: _propTypes.default.string,
    step: _propTypes.default.string
  }).isRequired,
  stepThree: _propTypes.default.shape({
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    text: _propTypes.default.string,
    step: _propTypes.default.string
  }).isRequired,
  unlockStep: _propTypes.default.shape({
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    text: _propTypes.default.string,
    step: _propTypes.default.string
  }).isRequired,
  expired: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    subtitle: _propTypes.default.string.isRequired,
    button: _propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      version: _propTypes.default.string.isRequired,
      redirectUrl: _propTypes.default.string.isRequired
    }).isRequired
  }).isRequired,
  mailSentTitle: _propTypes.default.string.isRequired,
  mailSentDescription: _propTypes.default.string.isRequired,
  setPasswordTitle: _propTypes.default.string.isRequired,
  setPasswordDescription: _propTypes.default.string.isRequired,
  loginTitle: _propTypes.default.string.isRequired,
  loginDescription: _propTypes.default.string.isRequired,
  loginButtonLabel: _propTypes.default.string.isRequired,
  loginButtonVersion: _propTypes.default.string.isRequired,
  errorMessages: _propTypes.default.shape({
    denied: _propTypes.default.string,
    noConfirmationNeeded: _propTypes.default.string,
    notRegistered: _propTypes.default.string,
    externalError: _propTypes.default.string,
    serverError: _propTypes.default.string,
    somethingWentWrong: _propTypes.default.string
  }).isRequired
};
var RegisterConfirmation = function RegisterConfirmation(props) {
  var successCode = window.location.hash.substr(1);
  var registerSucess = successCode === 'success';
  var validationFail = successCode === 'expired';
  var unlockSuccess = successCode === 'unlock-success';
  var getHeaderElement = function getHeaderElement() {
    if (registerSucess) {
      // StepSuccesHead
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 ".concat(BASE_CLASS, "-head")
      }, /*#__PURE__*/_react.default.createElement("h2", null, props.stepThree.title), /*#__PURE__*/_react.default.createElement("p", null, props.stepThree.text), /*#__PURE__*/_react.default.createElement("p", {
        className: "".concat(BASE_CLASS, "-subtitle")
      }, props.stepThree.subtitle));
    }
    if (unlockSuccess) {
      // StepUnlockSuccesHead
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 ".concat(BASE_CLASS, "-head")
      }, /*#__PURE__*/_react.default.createElement("h2", null, props.unlockStep.title), /*#__PURE__*/_react.default.createElement("p", null, props.unlockStep.text), /*#__PURE__*/_react.default.createElement("p", {
        className: "".concat(BASE_CLASS, "-subtitle")
      }, props.unlockStep.subtitle));
    }
    // StepOneHead
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 ".concat(BASE_CLASS, "-head")
    }, /*#__PURE__*/_react.default.createElement("h2", null, props.stepOne.title), /*#__PURE__*/_react.default.createElement("p", null, props.stepOne.text), /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(BASE_CLASS, "-subtitle")
    }, props.stepOne.subtitle));
  };
  var loginBtn = {
    text: props.loginButtonLabel,
    version: props.loginButtonVersion,
    onClick: function onClick() {
      window.location.replace(_ciamAuthWebClientLib.SessionHandler.generateCiamLoginUrl());
    }
  };
  var steps;
  if (unlockSuccess) {
    steps = [{
      name: 'Schritt',
      title: props.loginTitle,
      desc: props.loginDescription,
      active: true,
      success: true,
      icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "54",
        glyph: "icon_mail-2_54x54"
      }),
      button: loginBtn
    }];
  } else {
    steps = [{
      name: 'Schritt',
      title: props.mailSentTitle,
      desc: props.mailSentDescription,
      active: !registerSucess,
      success: registerSucess,
      icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "54",
        glyph: "icon_mail-2_54x54"
      })
    }, {
      name: 'Schritt',
      title: props.setPasswordTitle,
      desc: props.setPasswordDescription,
      active: false,
      success: registerSucess,
      icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "54",
        glyph: "icon_password_54x54"
      })
    }, {
      name: 'Schritt',
      title: props.loginTitle,
      desc: props.loginDescription,
      active: registerSucess,
      success: registerSucess,
      icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "54",
        glyph: "icon_user-2_54x54"
      })
    }];
    if (registerSucess) {
      steps[2].button = loginBtn;
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", null, validationFail ? /*#__PURE__*/_react.default.createElement(_LinkExpired.default, props.expired) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, getHeaderElement()), /*#__PURE__*/_react.default.createElement(_Stepbox.default, {
    steps: steps
  })));
};
var _default = exports.default = RegisterConfirmation;